'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _fluxActions = require('flux-actions');

var _immutable = require('immutable');

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _LegalConsentOptions = require('MeetingsBase/models/LegalConsentOptions');

var _LegalConsentOptions2 = _interopRequireDefault(_LegalConsentOptions);

var _LegalCommunicationConsent = require('MeetingsLib/models/LegalCommunicationConsent');

var _LegalCommunicationConsent2 = _interopRequireDefault(_LegalCommunicationConsent);

var _legalConsent = require('MeetingsBase/constants/legalConsent');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.List)();

exports.default = (0, _fluxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  if (state.size === 0) {
    var legalConsentOptions = _LegalConsentOptions2.default.from(action.payload.bookInfo.customParams.legalConsentOptions);
    var subscriptions = legalConsentOptions.getSubscriptions();
    return subscriptions.map(function (subscription) {
      var _ref;

      return new _LegalCommunicationConsent2.default((_ref = {}, _defineProperty(_ref, _legalConsent.CHECKBOX_KEYS.COMMUNICATION_TYPE_ID, subscription.communicationTypeId), _defineProperty(_ref, 'consented', false), _defineProperty(_ref, 'required', subscription.required), _ref));
    });
  }
  return state;
}), _defineProperty(_handleActions, _ActionTypes2.default.SET_GIVEN_CONSENT, function (state, action) {
  var indexToUpdate = state.findIndex(function (checkbox) {
    return checkbox[_legalConsent.CHECKBOX_KEYS.COMMUNICATION_TYPE_ID] === action[_legalConsent.CHECKBOX_KEYS.COMMUNICATION_TYPE_ID];
  });
  return state.setIn([indexToUpdate, 'consented'], action.consented);
}), _defineProperty(_handleActions, _ActionTypes2.default.RESET_CONSENT_RESPONSES, function (state) {
  return state.map(function (checkbox) {
    return checkbox.set('consented', false);
  });
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/stagedLegalConsentResponses.js
// module id = 534
// module chunks = 0